import React from "react";
import { Chip, QueryResult, Section } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { filteredByComponent } from "../../../store/sbomSlice";
import { getFileName, isMaliciousOrSuspicious } from "../../../utils";
import { LinkToReportTab } from "../../common";
import { useReportDispatch } from "../../hooks";
import { useGetComponentInfoQuery } from "../../services/fileBrowser.api";
import { useGetFileAndReportId } from "../useGetFileAndReportId";
import Classification from "./classification/Classification";
import styles from "./info.module.scss";
import ModelCardSection from "./modelCard/ModelCardSection";
import SoftwareIdentitySection from "./softwareIdentity/SoftwareIdentitySection";
const Info = () => {
    const { fileId, reportId } = useGetFileAndReportId();
    const dispatch = useReportDispatch();
    const { data, isLoading, isFetching, isError, error } = useGetComponentInfoQuery({
        reportId: reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const shouldShowClassification = data
        ? isMaliciousOrSuspicious(data.classification.classification) ||
            data.classification.overrides.length > 0
        : false;
    return (React.createElement(QueryResult, { status: getQueryStatus({
            data,
            isLoading,
            isFetching,
            isError,
            error,
        }) }, data && (React.createElement("div", { className: styles["file-info"] },
        shouldShowClassification ? (React.createElement(Classification, { classification: data.classification })) : null,
        React.createElement(SoftwareIdentitySection, { identity: data.identity, link: data.sbom ? (React.createElement(LinkToReportTab, { id: "view-in-sbom", to: REPORT_PAGES_ROUTES.SBOM_ROUTE, onClick: () => {
                    dispatch(filteredByComponent({
                        name: getFileName(data.info),
                        id: data.identity.uuid,
                    }));
                }, color: "link" }, "View in SBOM")) : undefined }),
        data.model_cards.map((modelCard, index) => (React.createElement(ModelCardSection, { key: modelCard.id, modelCard: modelCard, title: data.model_cards.length > 1
                ? `Model card: ${index + 1}`
                : "Model card" }))),
        data.tags.length > 0 ? (React.createElement(Section, null,
            React.createElement(Section.Title, { as: "h3" }, "Tags"),
            React.createElement(Section.Content, null,
                React.createElement("div", { className: styles.tags }, data.tags.toSorted().map((tag) => (React.createElement(Chip, { key: tag, label: tag }))))))) : null))));
};
export default Info;
//# sourceMappingURL=Info.js.map